// Simple theme - DEFAULT is dark theme since that's what the chart uses
export const LINECHART_THEME = {
    DEFAULT: {
        BACKGROUND: {
            DEFAULT: '#242b39',
            HAIKU: '#1C2531'
        },
        CELL: {
            ACTIVE: '#2E3E56',
            DEFAULT: 'transparent'
        },
        TEXT: {
            ACTIVE: '#ffffff',
            DEFAULT: '#4A6282'
        },
        BORDER: {
            DEFAULT: '#283547'
        },
        GRID: '#2A3647',
    }
};

const useLineChartTheme = () => {
    return { THEME: LINECHART_THEME.DEFAULT };
};

export default useLineChartTheme;